var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container py-20"},[_vm._v("   \n  "+_vm._s(_vm.hero.errorText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }